
export default {
  name: "Photographer",
  props: {
    title: String,
    photographer: Object,
    isIndex: Boolean,
  },
}
